import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadFilesComponent } from './download-files.component';

@NgModule({
  declarations: [
    DownloadFilesComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DownloadFilesComponent
  ]
})
export class DownloadFilesModule { }
